import { SessionStorageKeys } from './session-storage.constants';

type Keys = keyof typeof SessionStorageKeys;

type BaseItemParams = {
    key: Keys
    value: any
    moduleId?: number
};

type SetItemParams = BaseItemParams;

type GetItemParams = Omit<BaseItemParams, 'value'>;

type GetModuleDataParams = Pick<BaseItemParams, 'moduleId'>;

export const portalApplication = 0;

export const useSessionStorage = () => {
    const getModuleData = ({ moduleId }: GetModuleDataParams) => {
        const storedData = window.sessionStorage.getItem(`${moduleId}`);

        return storedData ? JSON.parse(storedData) : {};
    };
    const setItem = ({
        key,
        value,
        moduleId = portalApplication
    }: SetItemParams) => {
        try {
            const moduleData = getModuleData({ moduleId });

            moduleData[key] = value;

            window.sessionStorage.setItem(`${moduleId}`, JSON.stringify(moduleData));
        } catch (error) {
            console.error(error);
        }
    };
    const getItem = ({
        key, moduleId
    }: GetItemParams) => {
        try {
            const moduleData = getModuleData({ moduleId });

            return moduleData[key];
        } catch(error) {
            console.error(error);
        }
    };
    const clearSessionStorage = () => {
        window.sessionStorage.clear();
    };

    return {
        setItem,
        getItem,
        clearSessionStorage
    };
};
